import { DummyAdapter } from "@dashboard/services/errorTracking/adapters/Dummy";

import { ErrorTrackerFactory } from "./trackerFactory";

const errorTracker = ErrorTrackerFactory(DummyAdapter());

export default errorTracker;
